import {type FC, memo} from 'react';
import {MobileBottomUI} from './MobileBottomUI';
import {NavBottomWrapper} from './NavBottomWrapper';
import type {UpsellButtonsProps} from './UpsellButtons';

interface EventCreateNavigationProps {
  innerRef?: React.RefObject<HTMLDivElement>;
  showBottomNav: boolean;
  currentSection: string;
  isUsingPremiumFeature: boolean;
  usedPremiumFeature: boolean;
  isPremium: boolean;
  toggleDowngradeModal: () => void;
  handleGoPremiumClick: () => void;
  isLoading: boolean;
  isDesktop: boolean;
  // biome-ignore lint/style/useNamingConvention: allow invalid naming
  UpsellButtons?: FC<UpsellButtonsProps>;
}

export const EventCreateNavigation: FC<EventCreateNavigationProps> = memo(
  ({
    innerRef,
    showBottomNav,
    currentSection,
    isUsingPremiumFeature,
    usedPremiumFeature,
    isPremium,
    toggleDowngradeModal,
    handleGoPremiumClick,
    isLoading,
    isDesktop,
    UpsellButtons,
  }) => {
    const bottomCtas =
      usedPremiumFeature && !isPremium && UpsellButtons ? (
        <UpsellButtons
          toggleDowngradeModal={toggleDowngradeModal}
          handleGoPremiumClick={handleGoPremiumClick}
          isLoading={isLoading}
          isDesktop={isDesktop}
        />
      ) : null;

    return (
      <NavBottomWrapper
        innerRef={innerRef}
        showBottomNav={showBottomNav}
        currentSection={currentSection}
        isUsingPremiumFeature={isUsingPremiumFeature}
        bottomCtas={bottomCtas}
        isPremium={isPremium}
        usedPremiumFeature={usedPremiumFeature}
      >
        {!isDesktop && <MobileBottomUI />}
      </NavBottomWrapper>
    );
  }
);
